import { flightRootSaga } from 'flight-react/sagas'
import {fork} from 'redux-saga/effects'
import { watchCommonActions } from './common.saga'
import {watchUserAction} from './user.saga'

export function* rootSaga(){
    yield fork(watchUserAction)
    yield fork(watchCommonActions)
    yield fork(flightRootSaga)
}